<template>
  <section class="content">
    <div class="row center-block">   
      <box title="Arraste as categorias para a ordem que deseja no chatbot">
          <!-- /.box-header -->
          <div slot="body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-12">
                    <!-- <ul class="list-group">
                        <li class="list-group-item" v-for="cat in categorias">{{cat.nome}}</li>
                    </ul> -->
                    <!-- <draggable v-model="categorias" :options="{group:'people'}" @start="drag=true" @end="drag=false">
                        <div v-for="element in categorias" :key="element.id">{{element.nome}}</div>
                    </draggable> -->

                    <draggable class="list-group" element="ul" v-model="categorias" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                        <li class="list-group-item" v-for="(element, index) in categorias" :key="element.order">
                            {{element.nome}}
                            <span class="badge">{{index}}</span>
                        </li>
                    </draggable>
                    <router-link class="pageLink" to="/categorias">
                            <button class="btn btn-danger" >Cancelar</button>
                    </router-link>
                    <button class="btn btn-success" @click="gravarOrdem">
                      <i class="fa fa-check">  Gravar</i>
                    </button>
                    <!-- {{categorias}} -->
                </div>
              </div>
              </div>
              <!-- /.box-body -->
          </div>
      </box>


    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Box from './Box'
import draggable from 'vuedraggable'

// import routes from '../../routes.js'

export default {
  name: 'OrdenarCategorias',
  components: {
    'box': Box,
    draggable,
  },
  data () {
    return {
        categorias: [],
        editable: true,
        isDragging: false,
        delayedDragging: false
    }
  },
  created() {
        // console.log('CREATEEE ==> ', this.$route.params)
        axios.get(`${this.$store.state.api}categorias?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
            this.categorias = _.orderBy(response.data, 'posicao', 'asc')
            console.log('categorias ==> ', this.categorias);
            this.categorias = this.categorias.filter(el => !el.adicionais);
            // console.log('categorias filtradas ==> ', filtrados);

        })
  },
  methods: {
        onMove({ relatedContext, draggedContext }) {
            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            console.log('relatedElement => ', relatedElement)
      console.log('draggedElement => ', draggedElement)
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            );
        },
        gravarOrdem() {
            this.categorias.forEach((element, index) => {
                axios.post(this.$store.state.api+'categorias/insert', {
                    'alteracao': true,
                    'id_categoria': element.id,
                    'posicao': index,
                    'empresa': this.$store.state.empresa_fb_id
                })
            });
            this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Ordem Salva',
                    showConfirmButton: false,
                    timer: 1500
                })  
            this.$router.go(-1)
        }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    }
  }
}
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// OrderCategoria.vue?db373f4c